<div>
    <div>
        <p>
            Reason: {{data?.reason}}
        </p>
        <p>
            Status: {{data?.status}}
        </p>
    </div>
</div>